import {ChangeDetectionStrategy, Component, computed} from '@angular/core';
import {AuthService} from "../../services/auth.service";
import { NavLinkComponent } from '../nav-link/nav-link.component';
import { CacheClearerComponent } from '../cache-clearer/cache-clearer.component';

@Component({
    selector: 'app-nav-bar',
    templateUrl: './nav-bar.component.html',
    styleUrls: ['./nav-bar.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [CacheClearerComponent, NavLinkComponent]
})
export class NavBarComponent {

    domainsPat: RegExp = /^\/domains.*/;
    transactionsPat: RegExp = /^\/transactions.*/;
    dnsZonesPat: RegExp = /^\/dns-zones.*/;
    settingsPat: RegExp =/^\/settings.*/;
    adminPat: RegExp = /^\/admin.*/;
    bulkPat: RegExp = /^\/bulk.*/;
    flagsPat: RegExp = /^\/flags.*/;

    constructor(private authService: AuthService) {
    }

    isAdmin = computed(() => this.authService.isAdmin())
    isSuperAdmin = computed(() => this.authService.isSuperAdmin());
    isLoggedIn = computed(() => this.authService.isLoggedIn())
}
